// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"0de03ab7","247":"cb909672","517":"806da327","564":"b20aa198","652":"f1e9635f","982":"53fb7e16"}[chunkId] + ".chunk.css";
};